<!-- tslint:disable:template-cyclomatic-complexity -->
<div class="panel panel-no-border panel-no-padding" *ngIf="showIdentify">
    <div *ngIf="!showNearbyAssets">
        <div class="panel-title">
            <div class="title">
                <span>Layer Information</span>
                <span class="icon-ui-close" style="cursor: pointer;" (click)="hideIdentify()"></span>
            </div>
            <div class="content">
                <div>
                    <label for="sortType">Sort Type:</label>
                    <select id="sortType" [(ngModel)]="sortType">
                        <option *ngFor="let option of sortTypeOptions" value="{{ option }}">{{ sortTypeDisplayOptions[option] }}</option>
                    </select>
                </div>
                <div *ngIf="showShowAll">
                    <label class="toggle-switch">
                        <input type="checkbox" class="toggle-switch-input" [(ngModel)]="showAll">
                        <span class="toggle-switch-track margin-right-1"></span>
                        <span class="toggle-switch-label font-size--1"> Show All</span>
                    </label>
                </div>
            </div>
        </div>
        <div *ngIf="!loading" class="panel-container">
            <div class="panel-header">
                <span class="layer-info-name">{{ currentFeature?.layerName }}</span>
                <div class="paginator">
                    <button [disabled]="!hasPreviousFeature" class="btn btn-small arrow-botton">
                        <span class="icon-ui-left" (click)="previousFeature()"></span>
                    </button>
                    <span class="results">Result: {{ currentFeatureIndex + 1 }} of {{ features?.length }} </span>
                    <button [disabled]="!hasNextFeature" class="btn btn-small arrow-botton" (click)="nextFeature()">
                        <span class="icon-ui-right"></span>
                    </button>
                </div>
                <div *ngIf="currentFeature?.childTables && showAdditionalInformation">
                    <button class="additional-info btn btn-fill" (click)="showChildTables(currentFeature)">
                        <span>{{ areChildTablesDisplayed ? 'Hide': 'Show' }} Additional Information</span>
                        <span *ngIf="areChildTablesDisplayed" class="icon-ui-up"></span>
                        <span *ngIf="!areChildTablesDisplayed" class="icon-ui-down"></span>
                    </button>
                    <div class="child-table-selector" *ngIf="areChildTablesDisplayed">
                        <div *ngFor="let childTable of currentFeature?.childTables">
                            <button class="child-table-item btn btn-fill" [ngClass]="{'btn-clear': !currentChildTable || currentChildTable.tableId !== childTable.tableId}" *ngIf="childTable.childTableData" 
                                (click)="toggleCurrentChildTable(childTable)"
                                [disabled]="!childTable.childTableData || childTable.childTableData.length === 0">
                                {{ childTable.layerChildRelationshipName }} ({{ childTable.childTableData.length }})
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="panel-body">
                <!--Document Source Section-->
                <span class="document-source">
                    <mc-doc-source-ng #docSource [currentFeature]="currentFeature" (docSourcesUpdated)="docSourcesUpdatedHandler()"></mc-doc-source-ng>
                </span>
                <div class="attribute-content" *ngIf="!currentChildTable">
                    <ng-container *ngFor="let attribute of currentFeature?.attributes">
                        <div class="layer-data" *ngIf="(attribute && !attribute.hide) || showAll">
                            <span class="key" [ngClass]="{'domain': attribute.columnName !== attribute.displayName}" [attr.title]="attribute.columnName !== attribute.displayName ? attribute.columnName : null">{{ attribute.displayName }}: </span>
                            <span *ngIf="attribute.domainValue" class="value domain" [title]="attribute.value">{{ attribute.domainValue }}</span>
                            <span class="value" *ngIf="attribute.type === 'download-url' || attribute.type === 'open-url'">
                                <a *ngIf="attribute.type === 'download-url'" [href]="attribute.value" [innerText]="attribute.displayText ? attribute.displayText : attribute.value" download></a>
                                <a *ngIf="attribute.type === 'open-url'" [href]="attribute.value" [innerText]="attribute.displayText ? attribute.displayText : attribute.value" target="_blank" rel="noopener"></a>
                            </span>
                            <span class="value" *ngIf="!attribute.domainValue && !(attribute.type === 'download-url' || attribute.type === 'open-url')" [title]="attribute.value">{{ attribute | mcAttributeDateFilter:{ minShortYear: 80 } }}</span>
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="currentChildTable">
                    <div *ngIf="currentChildTable.hideDuplicateRecords"><button class="btn btn-fill" (click)="showDuplicateRecords(currentChildTable)">Duplicate records are hidden intentionally, click here to show all {{ currentChildTable.origialTableData.length }} records.</button></div>
                    <div class="paginator">
                        <button [disabled]="!hasPreviousChildTableData" class="btn btn-small arrow-botton">
                            <span class="icon-ui-left" (click)="previousChildTableData()"></span>
                        </button>
                        <span class="results">
                            Result: {{ currentChildTableDataIndex + 1 }} of
                            {{ currentChildTable?.childTableData.length }}
                        </span>
                        <button [disabled]="!hasNextChildTableData" class="btn btn-small arrow-botton" (click)="nextChildTableData()">
                            <span class="icon-ui-right"></span>
                        </button>
                    </div>
                    <span *ngIf="isCwopaUser">
                        <mc-doc-source-ng #docSourceChild [currentTable]="docSourceTable" (docSourcesUpdated)="docSourcesUpdatedHandler()"></mc-doc-source-ng>
                    </span>
                    <div class="child-table-data layer-data" *ngFor="let entry of currentChildTableData">
                        <span class="key">{{ entry[0] }}: </span>
                        <span class="value">{{ entry[1] }} </span>
                    </div>
                </div>
            </div>

            <div class="panel-footer">
                <div class="external-links" *ngIf="currentFeature?.externalLinks"></div>
                <button class="btn btn-small" (click)="openBufferWindow()" *ngIf="enableBuffer">Buffer Feature</button>
                <button *ngIf="showVideologBtn && currentFeatureHasCRS" class="btn btn-small" (click)="openVideolog()" title="Open Videolog"><i class="icon-ui-play"></i></button>
                <button *ngIf="showStreetViewBtn && currentFeatureHasCRS" class="btn btn-small" (click)="openStreetView()" title="Open StreetView"><i class="icon-ui-map-pin"></i></button>
                <button *ngIf="showNearbyAssetsBtn" class="btn btn-small nearby-assets-button" (click)="openNearbyAssets()" title="Find Nearby Assets">Nearby Assets</button>
                <slot name="buttons"></slot>
                <slot #reportLinks name="report-links"></slot>
            </div>
        </div>
    </div>
    <div *ngIf="showNearbyAssets">
        <mc-nearby-ng #nearbyAssets
                      [(active)]="showNearbyAssets"
                      (activeChange)="onNearbyActiveChange($event)"
                      [mapViewRef]="mapView"
                      [graphic]="currentFeature"
                      (status)="onNearbyStatusChange($event)"
                      (openVideoLogWithCoordinates)="openVideoLogWithCoordinates($event)"
                      (openStreetViewWithCoordinates)="openStreetViewWithCoordinates($event)">
        </mc-nearby-ng>
    </div>
    <div *ngIf="loading">
        <div class="loader is-active padding-leader-3 padding-trailer-3">
            <div class="loader-bars"></div>
            <div class="loader-text">Loading...</div>
        </div>
    </div>
</div>
